import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from './MyPage.module.css'; // CSS 모듈을 가져옵니다.

import physical_skills from '../../assets/a_diagnostic_test/physical_skills.svg';
import dexterity_skills from '../../assets/a_diagnostic_test/dexterity_skills.svg';
import spatial_perception_skills from '../../assets/a_diagnostic_test/spatial_perception_skills.svg';
import musical_skills from '../../assets/a_diagnostic_test/musical_skills.svg';
import Creativity_skills from '../../assets/a_diagnostic_test/Creativity_skills.svg';
import linguistic_skills from '../../assets/a_diagnostic_test/linguistic_skills.svg';
import logical_skills from '../../assets/a_diagnostic_test/logical_skills.svg';
import self_reflection_skills from '../../assets/a_diagnostic_test/self_reflection_skills.svg';
import interpersonal_skills from '../../assets/a_diagnostic_test/interpersonal_skills.svg';
import enviromental_friendliness_skills from '../../assets/a_diagnostic_test/enviromental_friendliness_skills.svg';
import artistic_visual_skills from '../../assets/a_diagnostic_test/artistic_visual_skills.svg';

const skillDescriptions = {
  physical_skills: {
    name: "신체, 운동 능력",
    description: "또래보다 뛰어난 운동신경과<br>체력을 가질 확률이 높고,<br>신체 학습과 순발력도 빠를 것으로 보입니다.",
    img: physical_skills
  },
  dexterity_skills: {
    name: "손재능",
    description: "손으로 만드는 일을 잘 해내는 경향이 있습니다. 다른 친구들보다 만들어 낸 결과물이 정교하거나 정확합니다.",
    img: dexterity_skills
  },
  spatial_perception_skills : {
    name: "공간지각력",
    description: "글로 쓰인 이미지를 머릿속에서 입체적으로 떠올리고 생각할 수 있습니다. 공간 배치 및 공간기억의 능력을 잘 발휘합니다.",
    img: spatial_perception_skills
  },
  musical_skills : {
    name: "음악능력",
    description: "정확한 음정으로 노래하거나 악기를 연주하는 능력이 뛰어납니다. 음을 잘 구분하고 감상하는 능력이 있습니다.",
    img: musical_skills
  },
  creativity_skills : {
    name: "창의력",
    description: "호기심이 많고 독특한 방법으로 문제를 해결하는 경향이 있습니다. 융통성 있는 아이디어를 낼 가능성이 높습니다.",
    img: Creativity_skills
  },
  linguistic_skills : {
    name: "언어능력",
    description: "말이나 글로 생각과 감정을 표현하는 능력이 뛰어 납니다. 다른 사람의 말과 글을 잘 이해할 수 있습니다.",
    img: linguistic_skills
  },
  logical_skills : {
    name: "수리, 논리력",
    description: "수학적 개념을 이해하고 계산하고 해결하는 능력을 가지고 있습니다. 논리적인 사고로 분석, 응용하는 것을 잘합니다.",
    img: logical_skills
  },
  self_reflection_skills : {
    name: "자기 성찰 능력",
    description: "자신의 생각과 감정을 알고 감정 조절을 합니다. 스스로 목표를 세우고 실행하며 결과에 대한 자기 책임을 잘 인정합니다.",
    img: self_reflection_skills
  },
  interpersonal_skills: {
    name: "대인관계 능력",
    description: "다른 사람의 마음이 자연스럽게 이해 되고 공감 능력이 높은 편입니다. 사람들과 잘 어울리며 관계를 잘 유지합니다.",
    img: interpersonal_skills
  },
  enviromental_friendliness_skills: {
    name: "자연친화력",
    description: "동물이나 식물에 대한 관심과 이해도가 높습니다. 자연보호에 관심이 많으며, 자연에 대해 깊게 탐구하려고 합니다.",
    img: enviromental_friendliness_skills
  },
  artistic_visual_skills: {
    name: "예술 시각 능력",
    description: "선, 색, 공간 등을 조화롭게 구성할 수 있으며 주변 사물이나 환경의 아름다움을 느끼고 표현하는데 익숙합니다.",
    img: artistic_visual_skills
  },
};

const apiUrl = process.env.REACT_APP_API_URL;  // 환경 변수로 API URL 불러오기

const MyPage = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [topSkills, setTopSkills] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false); // 우측 햄버거 메뉴 (로그아웃, 비밀번호 재설정 등)
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // 상위 3개 유형을 API에서 가져오는 함수
const fetchTopSkills = async () => {
  const cachedSkills = localStorage.getItem('topSkills');
  const cacheTime = localStorage.getItem('cacheTime');
  const now = new Date().getTime();

  if (cachedSkills && cacheTime && (now - cacheTime < 3600000)) {
    const parsedSkills = JSON.parse(cachedSkills);
    if (Array.isArray(parsedSkills) && parsedSkills.length > 0) {
      return parsedSkills.map(skillData => {
        // 철자 통일 (데이터베이스에 이름 잘못 넣었음 이슈)
        if (skillData[0] === "environmental_friendliness_skills") {
          return ["enviromental_friendliness_skills", skillData[1]];
        }
        return skillData;
        // 캐시된 데이터가 있으면 바로 return -> api 호출 안함
      });
    }
  }

  const token = localStorage.getItem('accessToken');
  try {
    // console.log('API 요청을 보냅니다: /aptitude_test/user-top-skills/'); // API 요청 시작 로그
    const response = await axios.get(`${apiUrl}/aptitude_test/user-top-skills/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const topSkills = response.data.map(skillData => {
      // 철자 통일
      if (skillData[0] === "environmental_friendliness_skills") {
        return ["enviromental_friendliness_skills", skillData[1]];
      }
      return skillData;
    });

    if (Array.isArray(topSkills) && topSkills.length > 0) {
      localStorage.setItem('topSkills', JSON.stringify(topSkills));
      localStorage.setItem('cacheTime', now);
      return topSkills;
    } else {
      console.error("No valid skills data received.");
      return [];
    }
  } catch (error) {
    if (error.response?.status === 401) {
      // 401 Unauthorized 처리
      
      navigate('/login'); // 로그인 페이지로 리디렉션
    } else {
      // 다른 에러 처리
      console.error('Error fetching top skills:', error);
    }
    return [];
  }
};

  const verifyAndRefreshToken = async () => {
    const accessToken = localStorage.getItem('accessToken');
    // console.log("MainPage.js에서 읽은 토큰:", accessToken);
    const refreshToken = localStorage.getItem('refreshToken');

    if (!accessToken) {
      setError('로그인이 필요합니다.');
      // navigate('/login');
      localStorage.clear(); // 로컬스토리지 초기화
      window.location.href = '/login'; // 로그인 페이지로 이동
      return;
    }

    try {
      await axios.post(`${apiUrl}/token/verify/`, { token: accessToken });
    } catch (error) {
      if (error.response && error.response.status === 401 && refreshToken) {
        try {
          const refreshResponse = await axios.post(`${process.env.REACT_APP_API_URL}/token/refresh/`, { refresh: refreshToken });
          const newAccessToken = refreshResponse.data.access;
          localStorage.setItem('accessToken', newAccessToken);
        } catch (refreshError) {
          // console.error('토큰 갱신 실패:', refreshError.response ? refreshError.response.data : refreshError.message);
          handleLogout();
        }
      } else {
        setError('토큰을 확인할 수 없습니다. 다시 로그인해주세요.');
        handleLogout();
      }
    }
  };

  const handleLogout = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    const accessToken = localStorage.getItem('accessToken');

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/accounts/logout/`, { refresh: refreshToken }, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('username');
      navigate('/login');
    } catch (error) {
      console.error('로그아웃 실패:', error);
      navigate('/login');
    }
  };

  useEffect(() => {
    const loadData = async () => {
      await verifyAndRefreshToken();
  
      // 로컬 스토리지에서 username 가져오기
      const savedUsername = localStorage.getItem('username');
      if (savedUsername) {
        setUserInfo({ username: savedUsername });
      }
  
      // 상위 3개 스킬 가져오기
      const skills = await fetchTopSkills();
      // console.log('Fetched skills:', skills); // 스킬 데이터가 어떻게 들어오는지 확인하는 로그 추가
  
      // 스킬명만 추출
      const skillNames = skills.map(skill => {
        // 스킬 배열에서 첫 번째 요소(스킬명)만 가져옴
        if (Array.isArray(skill) && skill.length > 0) {
          return skill[0]; // 스킬명만 반환
        }
        return skill; // 배열이 아닌 경우 그대로 반환
      });
  
      // console.log('Extracted skill names:', skillNames); // 추출한 스킬명을 확인하는 로그 추가
      setTopSkills(skillNames); // 상태에 저장
    };
  
    loadData();
  }, []);

  //// 우측 햄버거 메뉴 (로그아웃, 비밀번호 재설정 등)
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handlePasswordReset = () => {
    navigate('../ResetPW'); // 비밀번호 재설정 페이지로 이동
    closeMenu(); // 메뉴 닫기
  };

  const handleWithdrawal = () => {
    navigate('../Withdrawal'); // 비밀번호 재설정 페이지로 이동
    closeMenu(); // 메뉴 닫기
  }

  // // 화면 외 클릭 시 메뉴 닫기
  // useEffect(() => {
  //   const handleOutsideClick = (event) => {
  //     if (!event.target.closest(`.${styles.dropdownMenu}`) && !event.target.closest(`.${styles.hamburgerButton}`)) {
  //       closeMenu();
  //     }
  //   };

  //   document.addEventListener('mousedown', handleOutsideClick);
  //   return () => {
  //     document.removeEventListener('mousedown', handleOutsideClick);
  //   };
  // }, []);


    //// 우측 햄버거 메뉴 (로그아웃, 비밀번호 재설정 등) 끝.
  

  return (
    <div className={styles.pageContainer}>
            <div className={styles.header}>
        <p className={styles.title}>마이페이지</p>
        <button
          className={styles.hamburgerButton}
          onClick={toggleMenu}
          aria-label="햄버거 메뉴 열기"
        >
          &#x22EE;
        </button>
      </div>

      {menuOpen && (
        <div className={styles.modalOverlay} onClick={closeMenu}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <ul className={styles.menuli}>
              <li>
                <button className={styles.menuItemButton} onClick={handleLogout}>
                  로그아웃하기
                </button>
              </li>
              <hr className={styles.menuDivider} />
              <li>
                <button className={styles.menuItemButton} onClick={handlePasswordReset}>
                  비밀번호 재설정하기
                </button>
              </li>
              <hr className={styles.menuDivider} />
              <li>
                <button className={styles.menuItemButton_Membership_Withdrawal} onClick={handleWithdrawal}>
                  탈퇴하기
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}
      <p className={styles.subtitle}>
        {userInfo ? (
          <>
            <span className={styles.username}>{userInfo.username}</span> 의 상위 3가지 유형
          </>
        ) : (
          'Loading...'
        )}
      </p>

      {/* <h3 className={styles.subtitle}>글로의 상위 3가지 유형</h3> */}
      {topSkills.length > 0 ? (
        <div className={styles.skillsContainer}>
          {topSkills.map((skill, index) => {
            const skillKey = skill; // 스킬 키 값 사용
            const skillData = skillDescriptions[skillKey];

            if (!skillData) {
              console.error(`Skill description for "${skillKey}" not found.`);
              return null; // skillDescriptions에 해당 키가 없을 경우 렌더링하지 않음
            }

            return (
              <div key={index} className={styles.skillBlock}>
                <img src={skillData.img} alt={skillData.name} className={styles.skillImage} />
                <div className={styles.resulttextContainer}>
                  <p className={styles.skillsresulth2}>{skillData.name}</p>
                  <p className={styles.skillsresultp} dangerouslySetInnerHTML={{ __html: skillData.description }} />
                </div>
              </div>
            );
          })}

      {/* <button onClick={() => navigate('/test')} className={styles.retakeButton}>
        적성 유형 다시 파악하기
      </button> */}
        </div>
      ) : (
        <p className={styles.noSkillsMessage}>아직 진단검사를 진행하지 않았어요!</p>
      )}



      <button onClick={() => navigate('/test')} className={styles.retakeButton}>
        적성 유형 다시 파악하기
      </button>

      {/* <button onClick={handleLogout} className={styles.logoutButton}>
        로그아웃
      </button> */}

      {error && <p className={styles.errorMessage}>{error}</p>}
    </div>
  );
};

export default MyPage;
